// Mock Data for EduNexa 360 Multi-Tenant School ERP SaaS
// Future API replacement: Backend FastAPI /api endpoints with tenant school_id scoping

export const plansData = [{
  id: "plan_edunexa_monthly", name: "AWC School Complete", slug: "monthly",
  monthlyPrice: 999, yearlyPrice: 999, originalPrice: 1999,
  discount: "Limited offer — save ₹1,000 every month",
  studentLimit: "Unlimited", staffLimit: "Unlimited", storageLimit: "50 GB",
  trialDays: 0, featured: true, active: true,
  features: ["All ERP modules included", "Students, staff, attendance and fees", "Exams, homework and parent portal", "One isolated blank workspace per school", "Cloud updates and backups", "Renew monthly to retain access"]
}];

export const schoolsData = [
  {
    id: "school_apex_01",
    name: "Apex International Academy",
    code: "APEX01",
    slug: "apex",
    logo: "https://images.unsplash.com/photo-1580582932707-520aed937b7b?w=150&auto=format&fit=crop&q=80",
    contactPerson: "Dr. Rajesh Sharma",
    phone: "+91 98765 43210",
    whatsapp: "+91 98765 43210",
    email: "principal@apexacademy.edu.in",
    address: "Sector 21, Civil Lines",
    city: "New Delhi",
    district: "Central Delhi",
    state: "Delhi",
    pin: "110001",
    country: "India",
    board: "CBSE",
    affiliationNumber: "CBSE/19283/2018",
    website: "https://apexacademy.edu.in",
    currentSession: "2026-2027",
    timezone: "Asia/Kolkata",
    language: "English / Hindi",
    subscriptionPlan: "Professional",
    subscriptionStatus: "active",
    trialStart: "2026-01-01",
    trialEnd: "2026-01-15",
    subscriptionStart: "2026-01-15",
    subscriptionEnd: "2027-01-15",
    maxStudents: 1500,
    maxStaff: 80,
    maxBranches: 3,
    storageLimit: "50 GB",
    createdAt: "2026-01-01"
  },
  {
    id: "school_stxav_02",
    name: "St. Xavier's High School",
    code: "STXAV",
    slug: "stxavier",
    logo: "https://images.unsplash.com/photo-1523050854058-8df90110c9f1?w=150&auto=format&fit=crop&q=80",
    contactPerson: "Rev. Father Thomas",
    phone: "+91 91234 56789",
    whatsapp: "+91 91234 56789",
    email: "admin@stxavierdelhi.org",
    address: "MG Road, Camp",
    city: "Mumbai",
    district: "Mumbai City",
    state: "Maharashtra",
    pin: "400001",
    country: "India",
    board: "ICSE",
    affiliationNumber: "ICSE/49281/2015",
    website: "https://stxavierdelhi.org",
    currentSession: "2026-2027",
    timezone: "Asia/Kolkata",
    language: "English",
    subscriptionPlan: "Premium",
    subscriptionStatus: "active",
    trialStart: "2025-11-01",
    trialEnd: "2025-11-15",
    subscriptionStart: "2025-11-15",
    subscriptionEnd: "2026-11-15",
    maxStudents: 3000,
    maxStaff: 150,
    maxBranches: 5,
    storageLimit: "200 GB",
    createdAt: "2025-11-01"
  },
  {
    id: "school_dps_03",
    name: "Delhi Public School",
    code: "DPSBLR",
    slug: "dps",
    logo: "https://images.unsplash.com/photo-1546410531-bb4caa6b424d?w=150&auto=format&fit=crop&q=80",
    contactPerson: "Mrs. Sunita Rao",
    phone: "+91 99887 76655",
    whatsapp: "+91 99887 76655",
    email: "contact@dpsbangalore.com",
    address: "Electronic City Phase 1",
    city: "Bangalore",
    district: "Bangalore Urban",
    state: "Karnataka",
    pin: "560100",
    country: "India",
    board: "CBSE",
    affiliationNumber: "CBSE/88392/2012",
    website: "https://dpsbangalore.com",
    currentSession: "2026-2027",
    timezone: "Asia/Kolkata",
    language: "English",
    subscriptionPlan: "Enterprise",
    subscriptionStatus: "trial",
    trialStart: "2026-06-01",
    trialEnd: "2026-07-01",
    subscriptionStart: "2026-06-01",
    subscriptionEnd: "2027-06-01",
    maxStudents: 10000,
    maxStaff: 500,
    maxBranches: 20,
    storageLimit: "1 TB",
    createdAt: "2026-06-01"
  }
];

export const studentsData = [
  {
    id: "STU-2026-001",
    admissionNumber: "ADM-2026-101",
    firstName: "Aarav",
    middleName: "Kumar",
    lastName: "Sharma",
    dob: "2012-05-14",
    gender: "Male",
    bloodGroup: "B+",
    category: "General",
    religion: "Hindu",
    nationality: "Indian",
    motherTongue: "Hindi",
    class: "10",
    section: "A",
    stream: "Science",
    rollNumber: "1001",
    academicSession: "2026-2027",
    admissionDate: "2024-04-01",
    previousSchool: "St. Mary Public School",
    phone: "+91 98111 22334",
    email: "aarav.sharma@student.edu",
    address: "Flat 402, Sunshine Apartments, Civil Lines",
    city: "New Delhi",
    state: "Delhi",
    pin: "110001",
    photograph: "https://images.unsplash.com/photo-1539571696357-5a69c17a67c6?w=150&auto=format&fit=crop&q=80",
    fatherName: "Ramesh Sharma",
    motherName: "Sunita Sharma",
    guardianName: "",
    parentPhone: "+91 98111 22334",
    alternatePhone: "+91 98111 22335",
    parentEmail: "ramesh.sharma@gmail.com",
    occupation: "Software Engineer",
    feesStatus: "Paid",
    attendancePercentage: 94.5
  },
  {
    id: "STU-2026-002",
    admissionNumber: "ADM-2026-102",
    firstName: "Ananya",
    middleName: "",
    lastName: "Verma",
    dob: "2012-08-22",
    gender: "Female",
    bloodGroup: "O+",
    category: "OBC",
    religion: "Hindu",
    nationality: "Indian",
    motherTongue: "Hindi",
    class: "10",
    section: "A",
    stream: "Science",
    rollNumber: "1002",
    academicSession: "2026-2027",
    admissionDate: "2024-04-01",
    previousSchool: "Delhi Public Junior",
    phone: "+91 97222 33445",
    email: "ananya.verma@student.edu",
    address: "B-12, Green Park Extension",
    city: "New Delhi",
    state: "Delhi",
    pin: "110016",
    photograph: "https://images.unsplash.com/photo-1517841905240-472988babdf9?w=150&auto=format&fit=crop&q=80",
    fatherName: "Vikram Verma",
    motherName: "Pooja Verma",
    guardianName: "",
    parentPhone: "+91 97222 33445",
    alternatePhone: "",
    parentEmail: "vikram.verma@yahoo.com",
    occupation: "Bank Manager",
    feesStatus: "Pending",
    attendancePercentage: 88.0
  },
  {
    id: "STU-2026-003",
    admissionNumber: "ADM-2026-103",
    firstName: "Kabir",
    middleName: "Singh",
    lastName: "Patel",
    dob: "2013-01-10",
    gender: "Male",
    bloodGroup: "A+",
    category: "General",
    religion: "Sikh",
    nationality: "Indian",
    motherTongue: "Punjabi",
    class: "9",
    section: "B",
    stream: "General",
    rollNumber: "901",
    academicSession: "2026-2027",
    admissionDate: "2025-04-01",
    previousSchool: "Modern School",
    phone: "+91 96333 44556",
    email: "kabir.patel@student.edu",
    address: "House 54, Defence Colony",
    city: "New Delhi",
    state: "Delhi",
    pin: "110024",
    photograph: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&auto=format&fit=crop&q=80",
    fatherName: "Harpreet Singh Patel",
    motherName: "Simran Patel",
    guardianName: "",
    parentPhone: "+91 96333 44556",
    alternatePhone: "",
    parentEmail: "harpreet.patel@business.com",
    occupation: "Business",
    feesStatus: "Paid",
    attendancePercentage: 96.2
  },
  {
    id: "STU-2026-004",
    admissionNumber: "ADM-2026-104",
    firstName: "Diya",
    middleName: "",
    lastName: "Iyer",
    dob: "2013-11-05",
    gender: "Female",
    bloodGroup: "AB+",
    category: "General",
    religion: "Hindu",
    nationality: "Indian",
    motherTongue: "Tamil",
    class: "9",
    section: "B",
    stream: "General",
    rollNumber: "902",
    academicSession: "2026-2027",
    admissionDate: "2025-04-01",
    previousSchool: "KV IIT Delhi",
    phone: "+91 95444 55667",
    email: "diya.iyer@student.edu",
    address: "Flat 12B, Nilgiri Apartments",
    city: "New Delhi",
    state: "Delhi",
    pin: "110016",
    photograph: "https://images.unsplash.com/photo-1524504388940-b1c1722653e1?w=150&auto=format&fit=crop&q=80",
    fatherName: "Krishnan Iyer",
    motherName: "Radha Iyer",
    guardianName: "",
    parentPhone: "+91 95444 55667",
    alternatePhone: "",
    parentEmail: "krishnan.iyer@iitd.ac.in",
    occupation: "Professor",
    feesStatus: "Overdue",
    attendancePercentage: 79.8
  },
  {
    id: "STU-2026-005",
    admissionNumber: "ADM-2026-105",
    firstName: "Rohan",
    middleName: "Dev",
    lastName: "Das",
    dob: "2011-03-30",
    gender: "Male",
    bloodGroup: "B-",
    category: "SC",
    religion: "Hindu",
    nationality: "Indian",
    motherTongue: "Bengali",
    class: "11",
    section: "A",
    stream: "Science",
    rollNumber: "1101",
    academicSession: "2026-2027",
    admissionDate: "2023-04-01",
    previousSchool: "St. Xavier Kolkata",
    phone: "+91 94555 66778",
    email: "rohan.das@student.edu",
    address: "C-88, Lajpat Nagar",
    city: "New Delhi",
    state: "Delhi",
    pin: "110024",
    photograph: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=150&auto=format&fit=crop&q=80",
    fatherName: "Subrata Das",
    motherName: "Moumita Das",
    guardianName: "",
    parentPhone: "+91 94555 66778",
    alternatePhone: "",
    parentEmail: "subrata.das@gmail.com",
    occupation: "Consultant",
    feesStatus: "Paid",
    attendancePercentage: 91.0
  }
];

export const feeStructuresData = [
  { id: "FS-10", className: "Class 10", tuitionFee: 25000, admissionFee: 5000, examFee: 3000, libraryFee: 1000, annualCharges: 8000, total: 42000 },
  { id: "FS-9", className: "Class 9", tuitionFee: 22000, admissionFee: 5000, examFee: 2500, libraryFee: 1000, annualCharges: 7000, total: 37500 },
  { id: "FS-11", className: "Class 11", tuitionFee: 30000, admissionFee: 6000, examFee: 4000, libraryFee: 1500, annualCharges: 10000, total: 51500 },
  { id: "FS-12", className: "Class 12", tuitionFee: 32000, admissionFee: 0, examFee: 5000, libraryFee: 1500, annualCharges: 10000, total: 48500 }
];

export const feeTransactionsData = [
  { id: "TXN-98211", studentName: "Aarav Sharma", class: "10-A", amountPaid: 42000, feeType: "Full Annual Fee", mode: "Razorpay (Online)", date: "2026-04-05", status: "Success", receiptNo: "REC-2026-001" },
  { id: "TXN-98212", studentName: "Kabir Patel", class: "9-B", amountPaid: 37500, feeType: "Full Annual Fee", mode: "UPI (GooglePay)", date: "2026-04-08", status: "Success", receiptNo: "REC-2026-002" },
  { id: "TXN-98213", studentName: "Rohan Das", class: "11-A", amountPaid: 51500, feeType: "Full Annual Fee", mode: "Bank Transfer (NEFT)", date: "2026-04-10", status: "Success", receiptNo: "REC-2026-003" },
  { id: "TXN-98214", studentName: "Ananya Verma", class: "10-A", amountPaid: 15000, feeType: "Quarter 1 Tuition", mode: "Cash", date: "2026-04-12", status: "Success", receiptNo: "REC-2026-004" }
];

export const noticesData = [
  { id: "NOT-1", title: "Periodic Test-1 Examination Schedule", date: "2026-07-15", target: "Class 9 to 12", author: "Principal Office", content: "Periodic Test 1 for all secondary and senior secondary classes will commence from 1st August 2026. Detailed date sheet is available on portal." },
  { id: "NOT-2", title: "Independence Day Celebration & Cultural Fest", date: "2026-08-10", target: "All Students & Staff", author: "Cultural Committee", content: "Apex International Academy is celebrating 80th Independence Day with great zeal. All students must report in full ceremonial uniform by 7:30 AM." },
  { id: "NOT-3", title: "Quarterly Fee Deposit Reminder", date: "2026-07-01", target: "Parents", author: "Accounts Department", content: "Last date for submitting Q2 tuition and transport fees without late fine is 31st July 2026. Pay online via parent portal." }
];

export const attendanceMockData = [
  { date: "2026-07-10", totalStudents: 120, present: 112, absent: 8, percentage: 93.3 },
  { date: "2026-07-09", totalStudents: 120, present: 115, absent: 5, percentage: 95.8 },
  { date: "2026-07-08", totalStudents: 120, present: 108, absent: 12, percentage: 90.0 },
  { date: "2026-07-07", totalStudents: 120, present: 114, absent: 6, percentage: 95.0 },
  { date: "2026-07-04", totalStudents: 120, present: 116, absent: 4, percentage: 96.6 },
  { date: "2026-07-03", totalStudents: 120, present: 110, absent: 10, percentage: 91.6 },
  { date: "2026-07-02", totalStudents: 120, present: 113, absent: 7, percentage: 94.1 }
];

export const feeCollectionChartData = [
  { month: "Jan", collection: 1250000 },
  { month: "Feb", collection: 980000 },
  { month: "Mar", collection: 1450000 },
  { month: "Apr", collection: 3800000 },
  { month: "May", collection: 620000 },
  { month: "Jun", collection: 2100000 }
];
